document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".bridaltab");
  const contents = document.querySelectorAll(".tab-content");
  const GAP = 15;

  if (!tabs.length) return;

  /* -------------------------
     POSITION TABS (DESKTOP)
  --------------------------*/
  function positionTabs() {

    if (window.innerWidth <= 767) return;

    const container = document.querySelector(".tab-item");
    if (!container) return;

    let totalWidth = 0;

    tabs.forEach((tab, index) => {
      totalWidth += tab.offsetWidth;
      if (index !== tabs.length - 1) {
        totalWidth += GAP;
      }
    });

    const containerWidth = container.offsetWidth;
    let currentLeft = (containerWidth - totalWidth) / 2;

    tabs.forEach(tab => {
      tab.style.left = currentLeft + "px";
      currentLeft += tab.offsetWidth + GAP;
    });
  }

  /* -------------------------
     SET CONTENT PADDING
  --------------------------*/
  function setContentPadding(tab) {

    if (window.innerWidth <= 767) return;

    const target = document.getElementById(tab.dataset.target);
    if (!target) return;

    const tabHeight = tab.offsetHeight + 20;
    target.style.paddingTop = tabHeight + "px";
  }

  /* -------------------------
     TAB CLICK (NO TOGGLE)
  --------------------------*/
  tabs.forEach(tab => {

    tab.addEventListener("click", function () {

      // If already active → do nothing
      if (this.classList.contains("active")) {
        return;
      }

      const target = document.getElementById(this.dataset.target);

      // Remove active from all
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => {
        c.classList.remove("active");
        c.style.paddingTop = "";
      });

      // Activate current
      this.classList.add("active");

      if (target) {
        target.classList.add("active");
        setContentPadding(this);
      }

    });

  });

  /* -------------------------
     DEFAULT ACTIVE TAB
  --------------------------*/
  const firstTab = document.querySelector(".bridaltab.active") || tabs[0];

  if (firstTab) {
    firstTab.classList.add("active");
    const target = document.getElementById(firstTab.dataset.target);
    if (target) {
      target.classList.add("active");
      setContentPadding(firstTab);
    }
  }

  /* -------------------------
     RESIZE HANDLER
  --------------------------*/
  window.addEventListener("resize", function () {

    positionTabs();

    const activeTab = document.querySelector(".bridaltab.active");
    if (activeTab) {
      setContentPadding(activeTab);
    }

  });

  /* -------------------------
     INIT
  --------------------------*/
  positionTabs();

});